interface ContactAddressLike {
  street?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  isPrimary?: boolean | null;
}

interface ContactLike {
  firstName?: string | null;
  lastName?: string | null;
  displayName?: string | null;
  companyName?: string | null;
  addresses?: ContactAddressLike[] | null;
}

export function getContactDisplayName(contact: ContactLike): string {
  const personName = `${contact.firstName ?? ''} ${contact.lastName ?? ''}`.trim();
  return contact.displayName?.trim() || personName || contact.companyName?.trim() || '';
}

export function getPrimaryContactAddress<T extends ContactAddressLike>(
  addresses?: T[] | null,
): T | null {
  if (!addresses?.length) return null;
  return addresses.find((address) => address.isPrimary) ?? addresses[0] ?? null;
}

export function formatContactAddress(address?: ContactAddressLike | null): string {
  if (!address) return '';
  return [address.street, address.city, address.state, address.zip].filter(Boolean).join(', ');
}
